import React from 'react';
// solid icon
import FacebookSolid from '@menuzen/icon/build/solid/Facebook';
import PhoneSolid from '@menuzen/icon/build/solid/Phone';
import DrinkSolid from '@menuzen/icon/build/solid/Drink';
import FoodSolid from '@menuzen/icon/build/solid/Food';
import CalendarSolid from '@menuzen/icon/build/solid/Calendar';
import OrderSolid from '@menuzen/icon/build/solid/Order';
import EmailSolid from '@menuzen/icon/build/solid/Email';
import LocationSolid from '@menuzen/icon/build/solid/Location';
import TimeSolid from '@menuzen/icon/build/solid/Time';
import WebSolid from '@menuzen/icon/build/solid/Web';
import YoutubeSolid from '@menuzen/icon/build/solid/Youtube';
import WhatsappSolid from '@menuzen/icon/build/solid/Whatsapp';
import InstagramSolid from '@menuzen/icon/build/solid/Instagram';
import TwitterSolid from '@menuzen/icon/build/solid/Twitter';
import MessengerSolid from '@menuzen/icon/build/solid/Messenger';
import TelegramSolid from '@menuzen/icon/build/solid/Telegram';
import LinkSolid from '@menuzen/icon/build/solid/Link';
import OptionSolid from '@menuzen/icon/build/solid/Option';
import EasiSolid from '@menuzen/icon/build/solid/Easi';
import NinjaosSolid from '@menuzen/icon/build/solid/Ninjaos';
import CustomSolid from '@menuzen/icon/build/solid/Custom';
// shape icon
import FacebookShape from '@menuzen/icon/build/shape/Facebook';
import PhoneShape from '@menuzen/icon/build/shape/Phone';
import DrinkShape from '@menuzen/icon/build/shape/Drink';
import FoodShape from '@menuzen/icon/build/shape/Food';
import CalendarShape from '@menuzen/icon/build/shape/Calendar';
import OrderShape from '@menuzen/icon/build/shape/Order';
import EmailShape from '@menuzen/icon/build/shape/Email';
import LocationShape from '@menuzen/icon/build/shape/Location';
import TimeShape from '@menuzen/icon/build/shape/Time';
import WebShape from '@menuzen/icon/build/shape/Web';
import YoutubeShape from '@menuzen/icon/build/shape/Youtube';
import WhatsappShape from '@menuzen/icon/build/shape/Whatsapp';
import InstagramShape from '@menuzen/icon/build/shape/Instagram';
import TwitterShape from '@menuzen/icon/build/shape/Twitter';
import MessengerShape from '@menuzen/icon/build/shape/Messenger';
import TelegramShape from '@menuzen/icon/build/shape/Telegram';
import LinkShape from '@menuzen/icon/build/shape/Link';
import OptionShape from '@menuzen/icon/build/shape/Option';
import CustomShape from '@menuzen/icon/build/shape/Custom';
import {
    Menulog as MenulogShape,
    Gojek as GojekShape,
    Bolt as BoltShape,
    Grab as GrabShape,
    Grubhub as GrubhubShape,
    Swiggy as SwiggyShape,
    Delivery as DeliveryShape,
    Mrdfood as MrdfoodShape,
    Jumia as JumiaShape,
    Glovo as GlovoShape,
    Delivereasy as DelivereasyShape,
    Easi as EasiShape,
    Ubereat as UberEatShape,
    Deliveroo as DeliverooShape,
    Doordash as DoordashShape,
    Ninjaos as NinjaosShape,
} from '@menuzen/icon/build/shape';
// outline icon
import FacebookOutline from '@menuzen/icon/build/outline/Facebook';
import PhoneOutline from '@menuzen/icon/build/outline/Phone';
import DrinkOutline from '@menuzen/icon/build/outline/Drink';
import FoodOutline from '@menuzen/icon/build/outline/Food';
import CalendarOutline from '@menuzen/icon/build/outline/Calendar';
import OrderOutline from '@menuzen/icon/build/outline/Order';
import EmailOutline from '@menuzen/icon/build/outline/Email';
import LocationOutline from '@menuzen/icon/build/outline/Location';
import TimeOutline from '@menuzen/icon/build/outline/Time';
import WebOutline from '@menuzen/icon/build/outline/Web';
import YoutubeOutline from '@menuzen/icon/build/outline/Youtube';
import WhatsappOutline from '@menuzen/icon/build/outline/Whatsapp';
import InstagramOutline from '@menuzen/icon/build/outline/Instagram';
import TwitterOutline from '@menuzen/icon/build/outline/Twitter';
import MessengerOutline from '@menuzen/icon/build/outline/Messenger';
import TelegramOutline from '@menuzen/icon/build/outline/Telegram';
import UberEatOutline from '@menuzen/icon/build/outline/UberEat';
import DeliverooOutline from '@menuzen/icon/build/outline/Deliveroo';
import DoordashOutline from '@menuzen/icon/build/outline/Doordash';
import {
    Menulog,
    Gojek,
    Bolt,
    Grab,
    Grubhub,
    Swiggy,
    Delivery,
    Mrdfood,
    Jumia,
    Glovo,
    Delivereasy,
    Easi,
    Restaurant,
    ClockIcon,
    ImageIcon,
    Custom,
    Contact,
    User,
    Link1,
    OrderLink,
} from '@menuzen/icon/build/outline';
import BoltSolid from '@menuzen/icon/build/solid/Bolt';
import JumiaSolid from '@menuzen/icon/build/solid/Jumia';
import GojekSolid from '@menuzen/icon/build/solid/Gojek';
import GrabSolid from '@menuzen/icon/build/solid/Grab';
import DeliverySolid from '@menuzen/icon/build/solid/Delivery';
import DelivereasySolid from '@menuzen/icon/build/solid/Delivereasy';
import GrubhubSolid from '@menuzen/icon/build/solid/Grubhub';
import GlovoSolid from '@menuzen/icon/build/solid/Glovo';
import MenulogSolid from '@menuzen/icon/build/solid/Menulog';
import SwiggySolid from '@menuzen/icon/build/solid/Swiggy';
import MrdfoodSolid from '@menuzen/icon/build/solid/Mrdfood';
import UbereatSolid from '@menuzen/icon/build/solid/Ubereat';
import DeliverooSolid from '@menuzen/icon/build/solid/Deliveroo';
import DoordashSolid from '@menuzen/icon/build/solid/Doordash';
import { CornerStyle, IconStyle } from '@mnz/builder';
import { getBorderCSS } from '../../style';

interface Props {
    type: IconStyle;
    icon: string;
    size: number;
    color?: string;
    corner?: CornerStyle;
    backgroundColor?: string;
}

const LabelIcon: React.FC<Props> = ({
    type,
    icon,
    size,
    color = '#242A36',
    backgroundColor = 'transparent',
    corner,
}) => {
    const style: React.CSSProperties = {
        fontSize: size,
        color: color,
        overflow: 'hidden',
        flexShrink: 0,
        backgroundColor: backgroundColor,
        ...getBorderCSS({ corner, isIcon: true }),
    };
    //TODO Should we remove Switch -> Object? I think it will be more clean and more fast. (KAI)
    switch (type) {
        case 'solid':
            switch (icon) {
                case 'Facebook':
                    return (
                        <div style={style}>
                            <FacebookSolid />
                        </div>
                    );
                case 'Whatsapp':
                    return (
                        <div style={style}>
                            <WhatsappSolid />
                        </div>
                    );
                case 'Instagram':
                    return (
                        <div style={style}>
                            <InstagramSolid />
                        </div>
                    );
                case 'Phone':
                    return (
                        <div style={style}>
                            <PhoneSolid />
                        </div>
                    );
                case 'Email':
                    return (
                        <div style={style}>
                            <EmailSolid />
                        </div>
                    );
                case 'Food':
                    return (
                        <div style={style}>
                            <FoodSolid />
                        </div>
                    );
                case 'Drink':
                    return (
                        <div style={style}>
                            <DrinkSolid />
                        </div>
                    );
                case 'Location':
                    return (
                        <div style={style}>
                            <LocationSolid />
                        </div>
                    );
                case 'Order':
                    return (
                        <div style={style}>
                            <OrderSolid />
                        </div>
                    );
                case 'Web':
                    return (
                        <div style={style}>
                            <WebSolid />
                        </div>
                    );
                case 'Time':
                    return (
                        <div style={style}>
                            <TimeSolid />
                        </div>
                    );
                case 'Calendar':
                    return (
                        <div style={style}>
                            <CalendarSolid />
                        </div>
                    );
                case 'Youtube':
                    return (
                        <div style={style}>
                            <YoutubeSolid />
                        </div>
                    );
                case 'Twitter':
                    return (
                        <div style={style}>
                            <TwitterSolid />
                        </div>
                    );
                case 'Messenger':
                case 'Facebook_messenger':
                    return (
                        <div style={style}>
                            <MessengerSolid />
                        </div>
                    );
                case 'Telegram':
                    return (
                        <div style={style}>
                            <TelegramSolid />
                        </div>
                    );
                case 'Link':
                    return (
                        <div style={style}>
                            <LinkSolid />
                        </div>
                    );
                case 'Option':
                    return (
                        <div style={style}>
                            <OptionSolid />
                        </div>
                    );
                case 'Easi':
                    return (
                        <div style={style}>
                            <EasiSolid />
                        </div>
                    );
                case 'Bolt':
                    return (
                        <div style={style}>
                            <BoltSolid />
                        </div>
                    );
                case 'Jumia':
                    return (
                        <div style={style}>
                            <JumiaSolid />
                        </div>
                    );
                case 'Delivery':
                    return (
                        <div style={style}>
                            <DeliverySolid />
                        </div>
                    );
                case 'Delivereasy':
                    return (
                        <div style={style}>
                            <DelivereasySolid />
                        </div>
                    );
                case 'Gojek':
                    return (
                        <div style={style}>
                            <GojekSolid />
                        </div>
                    );
                case 'Grab':
                    return (
                        <div style={style}>
                            <GrabSolid />
                        </div>
                    );
                case 'Grubhub':
                    return (
                        <div style={style}>
                            <GrubhubSolid />
                        </div>
                    );
                case 'Glovo':
                    return (
                        <div style={style}>
                            <GlovoSolid />
                        </div>
                    );
                case 'Mrdfood':
                    return (
                        <div style={style}>
                            <MrdfoodSolid />
                        </div>
                    );
                case 'Swiggy':
                    return (
                        <div style={style}>
                            <SwiggySolid />
                        </div>
                    );
                case 'Menulog':
                    return (
                        <div style={style}>
                            <MenulogSolid />
                        </div>
                    );
                case 'Ubereats':
                    return (
                        <div style={style}>
                            <UbereatSolid />
                        </div>
                    );
                case 'Deliveroo':
                    return (
                        <div style={style}>
                            <DeliverooSolid />
                        </div>
                    );
                case 'Doordash':
                    return (
                        <div style={style}>
                            <DoordashSolid />
                        </div>
                    );
                case 'Ninjaos':
                    return (
                        <div style={style}>
                            <NinjaosSolid />
                        </div>
                    );
                case 'Custom':
                    return (
                        <div style={style}>
                            <CustomSolid />
                        </div>
                    );

                default:
                    return <></>;
            }
        case 'shape':
            switch (icon) {
                case 'Facebook':
                    return (
                        <div style={style}>
                            <FacebookShape />
                        </div>
                    );
                case 'Whatsapp':
                    return (
                        <div style={style}>
                            <WhatsappShape />
                        </div>
                    );
                case 'Instagram':
                    return (
                        <div style={style}>
                            <InstagramShape />
                        </div>
                    );
                case 'Phone':
                    return (
                        <div style={style}>
                            <PhoneShape />
                        </div>
                    );
                case 'Email':
                    return (
                        <div style={style}>
                            <EmailShape />
                        </div>
                    );
                case 'Food':
                    return (
                        <div style={style}>
                            <FoodShape />
                        </div>
                    );
                case 'Drink':
                    return (
                        <div style={style}>
                            <DrinkShape />
                        </div>
                    );
                case 'Location':
                    return (
                        <div style={style}>
                            <LocationShape />
                        </div>
                    );
                case 'Order':
                    return (
                        <div style={style}>
                            <OrderShape />
                        </div>
                    );
                case 'Web':
                    return (
                        <div style={style}>
                            <WebShape />
                        </div>
                    );
                case 'Time':
                    return (
                        <div style={style}>
                            <TimeShape />
                        </div>
                    );
                case 'Calendar':
                    return (
                        <div style={style}>
                            <CalendarShape />
                        </div>
                    );
                case 'Youtube':
                    return (
                        <div style={style}>
                            <YoutubeShape />
                        </div>
                    );
                case 'Twitter':
                    return (
                        <div style={style}>
                            <TwitterShape />
                        </div>
                    );
                case 'Messenger':
                case 'Facebook_messenger':
                    return (
                        <div style={style}>
                            <MessengerShape />
                        </div>
                    );
                case 'Telegram':
                    return (
                        <div style={style}>
                            <TelegramShape />
                        </div>
                    );
                case 'Link':
                    return (
                        <div style={style}>
                            <LinkShape />
                        </div>
                    );
                case 'Option':
                    return (
                        <div style={style}>
                            <OptionShape />
                        </div>
                    );
                case 'Ubereats':
                    return (
                        <div style={style}>
                            <UberEatShape />
                        </div>
                    );
                case 'Doordash':
                    return (
                        <div style={style}>
                            <DoordashShape />
                        </div>
                    );
                case 'Deliveroo':
                    return (
                        <div style={style}>
                            <DeliverooShape />
                        </div>
                    );
                case 'Bolt':
                    return (
                        <div style={style}>
                            <BoltShape />
                        </div>
                    );
                case 'Jumia':
                    return (
                        <div style={style}>
                            <JumiaShape />
                        </div>
                    );
                case 'Delivery':
                    return (
                        <div style={style}>
                            <DeliveryShape />
                        </div>
                    );
                case 'Delivereasy':
                    return (
                        <div style={style}>
                            <DelivereasyShape />
                        </div>
                    );
                case 'Easi':
                    return (
                        <div style={style}>
                            <EasiShape />
                        </div>
                    );
                case 'Gojek':
                    return (
                        <div style={style}>
                            <GojekShape />
                        </div>
                    );
                case 'Grab':
                    return (
                        <div style={style}>
                            <GrabShape />
                        </div>
                    );
                case 'Grubhub':
                    return (
                        <div style={style}>
                            <GrubhubShape />
                        </div>
                    );
                case 'Glovo':
                    return (
                        <div style={style}>
                            <GlovoShape />
                        </div>
                    );
                case 'Mrdfood':
                    return (
                        <div style={style}>
                            <MrdfoodShape />
                        </div>
                    );
                case 'Swiggy':
                    return (
                        <div style={style}>
                            <SwiggyShape />
                        </div>
                    );
                case 'Menulog':
                    return (
                        <div style={style}>
                            <MenulogShape />
                        </div>
                    );
                case 'Ninjaos':
                    return (
                        <div style={style}>
                            <NinjaosShape />
                        </div>
                    );
                case 'Custom':
                    return (
                        <div style={style}>
                            <CustomShape />
                        </div>
                    );

                default:
                    return <></>;
            }
        case 'outline':
            switch (icon) {
                case 'Facebook':
                    return (
                        <div style={style}>
                            <FacebookOutline />
                        </div>
                    );
                case 'Whatsapp':
                    return (
                        <div style={style}>
                            <WhatsappOutline />
                        </div>
                    );
                case 'Instagram':
                    return (
                        <div style={style}>
                            <InstagramOutline />
                        </div>
                    );
                case 'Phone':
                    return (
                        <div style={style}>
                            <PhoneOutline />
                        </div>
                    );
                case 'Email':
                    return (
                        <div style={style}>
                            <EmailOutline />
                        </div>
                    );
                case 'Food':
                    return (
                        <div style={style}>
                            <FoodOutline />
                        </div>
                    );
                case 'Drink':
                    return (
                        <div style={style}>
                            <DrinkOutline />
                        </div>
                    );
                case 'Location':
                    return (
                        <div style={style}>
                            <LocationOutline />
                        </div>
                    );
                case 'Order':
                    return (
                        <div style={style}>
                            <OrderOutline />
                        </div>
                    );
                case 'Web':
                    return (
                        <div style={style}>
                            <WebOutline />
                        </div>
                    );
                case 'Time':
                    return (
                        <div style={style}>
                            <TimeOutline />
                        </div>
                    );
                case 'Calendar':
                    return (
                        <div style={style}>
                            <CalendarOutline />
                        </div>
                    );
                case 'Youtube':
                    return (
                        <div style={style}>
                            <YoutubeOutline />
                        </div>
                    );
                case 'Twitter':
                    return (
                        <div style={style}>
                            <TwitterOutline />
                        </div>
                    );
                case 'Messenger':
                case 'Facebook_messenger':
                    return (
                        <div style={style}>
                            <MessengerOutline />
                        </div>
                    );
                case 'Telegram':
                    return (
                        <div style={style}>
                            <TelegramOutline />
                        </div>
                    );
                case 'Link':
                    return (
                        <div style={style}>
                            <LinkSolid />
                        </div>
                    );
                case 'Option':
                    return (
                        <div style={style}>
                            <OptionSolid />
                        </div>
                    );
                case 'Ubereats':
                    return (
                        <div style={style}>
                            <UberEatOutline />
                        </div>
                    );
                case 'Doordash':
                    return (
                        <div style={style}>
                            <DoordashOutline />
                        </div>
                    );
                case 'Deliveroo':
                    return (
                        <div style={style}>
                            <DeliverooOutline />
                        </div>
                    );
                case 'Bolt':
                    return (
                        <div style={style}>
                            <Bolt />
                        </div>
                    );
                case 'Jumia':
                    return (
                        <div style={style}>
                            <Jumia />
                        </div>
                    );
                case 'Delivery':
                    return (
                        <div style={style}>
                            <Delivery />
                        </div>
                    );
                case 'Delivereasy':
                    return (
                        <div style={style}>
                            <Delivereasy />
                        </div>
                    );
                case 'Easi':
                    return (
                        <div style={style}>
                            <Easi />
                        </div>
                    );
                case 'Gojek':
                    return (
                        <div style={style}>
                            <Gojek />
                        </div>
                    );
                case 'Grab':
                    return (
                        <div style={style}>
                            <Grab />
                        </div>
                    );
                case 'Grubhub':
                    return (
                        <div style={style}>
                            <Grubhub />
                        </div>
                    );
                case 'Glovo':
                    return (
                        <div style={style}>
                            <Glovo />
                        </div>
                    );
                case 'Mrdfood':
                    return (
                        <div style={style}>
                            <Mrdfood />
                        </div>
                    );
                case 'Swiggy':
                    return (
                        <div style={style}>
                            <Swiggy />
                        </div>
                    );
                case 'Menulog':
                    return (
                        <div style={style}>
                            <Menulog />
                        </div>
                    );
                case 'Ninjaos':
                    return (
                        <div style={style}>
                            <NinjaosSolid />
                        </div>
                    );
                case 'Basicinfo':
                    return (
                        <div style={style}>
                            <Restaurant />
                        </div>
                    );
                case 'Social':
                    return (
                        <div style={style}>
                            <User />
                        </div>
                    );
                case 'Customlink':
                    return (
                        <div style={style}>
                            <Link1 />
                        </div>
                    );
                case 'Contact':
                    return (
                        <div style={style}>
                            <Contact />
                        </div>
                    );
                case 'Openinghours':
                    return (
                        <div style={style}>
                            <ClockIcon />
                        </div>
                    );
                case 'Imagegallery':
                    return (
                        <div style={style}>
                            <ImageIcon />
                        </div>
                    );
                case 'Orderlink':
                    return (
                        <div style={style}>
                            <OrderLink />
                        </div>
                    );
                case 'Custom':
                    return (
                        <div style={style}>
                            <Custom />
                        </div>
                    );

                default:
                    return <></>;
            }
        default:
            return <></>;
    }
};

export default LabelIcon;
